<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <mat-card-title
              >{{ "salesforceosu.authentication_details" | translate }}</mat-card-title
            >
          </mat-card-header>
          <mat-card-content style="text-align: center; padding: 40px;">
            <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-padding-bottom-20">
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldSalesForceOsuUrl" class="mat-block">
                  <input
                    id="txtSalesForceOsuUrl"
                    matInput
                    [placeholder]="'salesforceosu.url' | translate"
                    formControlName="url"
                    [required]="isRequired('url')"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldSalesForceOsuClientId" class="mat-block">
                  <input
                    id="txtSalesForceOsuClientId"
                    matInput
                    [placeholder]="'salesforceosu.client_id' | translate"
                    formControlName="clientId"
                    [required]="isRequired('clientId')"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldSalesForceOsuSecretKey" class="mat-block">
                  <input
                    id="txtSalesForceOsuSecretKey"
                    matInput
                    type="password"
                    [placeholder]="'salesforceosu.secret_key' | translate"
                    formControlName="secretKey"
                    [required]="isRequired('secretKey')"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldSalesForceOsuGrantType" class="mat-block">
                  <input
                    id="txtSalesForceOsuGrantType"
                    matInput
                    type="text"
                    [placeholder]="'salesforceosu.grant_type' | translate"
                    formControlName="grantType"
                    [required]="isRequired('grantType')"
                  />
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <div fxFlex="20" class="u-text-left">
              <mat-card-title>{{ "salesforceosu.api_details" | translate }}</mat-card-title>
            </div>
            <div fxFlex="80" class="u-text-right">
              <button
                [disabled]="action=='view' || isWebReturnsSalesforceOSUAddDisabled "
                mat-flat-button
                color="primary"
                (click)="openSalesforceOSUSelectApiPopup();"
              >
                {{ 'salesforceosu.add' | translate}}
              </button>
            </div>
          </mat-card-header>
          <mat-card-content
            *ngFor="let apiDetails of parentForm.get(authControlKey).get('salesforceOSUApiDetails')['controls']; let i = index"
            formArrayName="salesforceOSUApiDetails"
          >
            <div [formGroupName]="i">
              <div fxFlex="80">
                <mat-accordion>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ apiDetails.value.selectedApi}}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div fxLayout="row wrap" fxLayoutGap="20px grid">
                      <div fxFlex="50">
                        <mat-form-field class="mat-block">
                          <input
                            id="ebasketURL"
                            [required]="isRequired('url')"
                            formControlName="url"
                            matInput
                            [placeholder]="
                    'salesforceosu.url' |
                    translate"
                          />
                        </mat-form-field>
                      </div>
                      <div fxFlex="50">
                        <mat-form-field class="mat-block">
                          <mat-select
                            id="ebasketMethod"
                            [required]="isRequired('method')"
                            formControlName="method"
                            [placeholder]="
                      'salesforceosu.select_method' |
                      translate"
                          >
                            <mat-option
                              *ngFor="let methods of method_types"
                              [value]="methods.value"
                            >
                              {{methods.name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
              <div fxFlex="20" class="u-text-right">
                <button
                  [disabled]="action=='view'"
                  mat-flat-button
                  color="primary"
                  (click)="deleteSalesforceOSUApiDetailContainer(i);"
                >
                  {{ 'salesforceosu.delete' | translate}}
                </button>
              </div>
            </div>
          </mat-card-content>
          <div
            *ngFor="let apiDetails of parentForm.get(authControlKey).get('salesforceOSUApiDetails')['controls']; let i = index"
          >
            <mat-error
              *ngIf="(action !== 'view') && (!apiDetails.value.url || !apiDetails.value.method)"
            >
              {{"salesforceosu.api_and_authentication_details_required" | translate }}
            </mat-error>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
